// API Configuration
// Note: For Azure Static Apps, environment variables are not available at runtime
// So we use build-time environment variables or hardcoded values

const API_CONFIG = {
  // STJV instance is multi-tenant: internal NSI users + allow-listed partner tenants.
  // 'external' makes MSAL use the /common authority so users from other tenants can sign in.
  // Requires the SPA + API app registrations to be multi-tenant, and the backend to gate
  // access with ALLOWED_TENANT_IDS. Override at build time with REACT_APP_DEPLOYMENT_AUDIENCE.
  DEPLOYMENT_AUDIENCE: process.env.REACT_APP_DEPLOYMENT_AUDIENCE || 'external',
  // Base API URL - change this for different environments
  BASE_URL: process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001/api'
      : 'https://api.stjv.riims.nsieng.com/api'
  ),
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'https://zealous-flower-061166f1e.7.azurestaticapps.net/',
};


export default API_CONFIG;
